/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useContext, useState } from 'react';
import AnimatedButton from '../../components/Button';
import HTMLViewer from '../../components/HTMLViewer';
import ApplicationContext from '../../context/ApplicationContext';
import './styles.css';
import BannerImage from './BannerImage';
import DatePickerPicker from '../../components/DatePicker';
import AnimatedPageFade from '../../components/Animations/AnimatedPageFade';
import { dataService } from '../../services/data.service';
import { generateDeviceFingerprint, handleToast } from '../../helpers/CommonFunctions';
import ThreeDotsBlackLoader from '../../components/LoadingDots/ThreeDotsBlack';
import { authLanguageContent } from './authLanguageContent';

function DOBPage(props) {
    const { facilityData, selectedLanguage,getCurrentSession, setLoading, selectedLanguageName, tempToken } = useContext(ApplicationContext);
    const [loader, setLoader] = useState(false);
    const [message, setMessage] = useState('');
    const [pickerValue, setPickerValue] = useState({
        year: '1980',
        month: '01',
        day: '01',
    })

    const handleSubmit = () => {
        setLoader(true);
        setMessage('');
        let dateString = `${pickerValue.month}/${pickerValue.day}/${pickerValue.year}`;
        const payload = {
            "date_of_birth": dateString,
            'timezone': Intl.DateTimeFormat().resolvedOptions().timeZone
        }
        dataService.verifyDOB(tempToken, payload).then(async(res) => {
            if(res.error === false) {
                sessionStorage.setItem('session', res.data.access_token);
                sessionStorage.setItem('token', tempToken);
                const payload = {
                    fingerprint_id: generateDeviceFingerprint()
                }
                dataService.updateDeviceFingerprint(res.data.access_token,payload).then((res) => {
                    if(res.error === false) {
                        setLoader(false);
                        setLoading(true);
                        getCurrentSession();
                    }
                })
            } else {
                setLoader(false);
                setMessage(res.data.data.message);
            }
        })
    }

    return (
        <AnimatedPageFade className='flex flex-col justify-between relative h-welcome auth'>
            <div className='p-[8px]'>
                <p className={`text-center font-semibold text-[#64A003] text-[24px] border-b border-[#D7D7D7] py-[10px] lg:text-[26px] xl:text-[32px] 2xl:text-[38px] ${selectedLanguage === 'ar' ? 'dir-rtl' : ''}`}>{authLanguageContent['welcome'][selectedLanguage]}</p>
                <div className={`mt-[12px]`}>
                    <span className={selectedLanguage === 'ar' ? 'dir-rtl' : ''}>
                        {message !== '' && handleToast(authLanguageContent[message.toLowerCase().replaceAll(' ', '-').replaceAll(`'`, '')][selectedLanguage], 'error', setMessage, selectedLanguage)}
                    </span>
                    <p className={`text-sm text-[#007EB4] font-semibold text-center ${selectedLanguage === 'ar' ? 'dir-rtl' : ''}`}>{authLanguageContent['patient-dob'][selectedLanguage]}</p>
                    <div className='mt-[22px] mx-[36px] relative fold'>
                        <DatePickerPicker pickerValue={pickerValue} setPickerValue={setPickerValue} />
                        <div className='overlay'>
                            <div className='flex justify-around items-center gap-[20px]'>
                                <div className='h-[48px] w-[62px] rounded-t-[12px] bg-[#D7D7D7]' />
                                <div className='h-[48px] w-[62px] rounded-t-[12px] bg-[#D7D7D7]' />
                                <div className='h-[48px] w-[62px] rounded-t-[12px] bg-[#D7D7D7]' />
                            </div>
                            <div className='h-[48px] w-full bg-white border-t border-b border-[#70B503]' />
                            <div className='flex justify-around items-center gap-[20px]'>
                                <div className='h-[48px] w-[62px] rounded-b-[12px] bg-[#D7D7D7]' />
                                <div className='h-[48px] w-[62px] rounded-b-[12px] bg-[#D7D7D7]' />
                                <div className='h-[48px] w-[62px] rounded-b-[12px] bg-[#D7D7D7]' />
                            </div>
                        </div>
                    </div>
                    <div className='facility-profile mt-[55px] text-justify text-sm'>
                        <HTMLViewer htmlContent={facilityData.authentication_legal_consent[selectedLanguageName]} />
                    </div>
                    <div className='flex justify-center mt-[59px]'>
                        <AnimatedButton handleClick={() => handleSubmit()} disabled={loader} id="agree_button" className={`font-semibold text-gray h-[40px] min-w-[200px] ${loader ? 'w-[200px]' : 'pl-[41px] w-fit'} text-[16px] md:text-[18px] lg:text-[18px] xl:text-[18px] 2xl:text-[18px] justify-center`}>
                            {loader ? <ThreeDotsBlackLoader /> : authLanguageContent['i-agree'][selectedLanguage]}
                            {!loader && <img src="/images/next.svg" alt="next" className='ml-[1.2em] w-[1.7em] h-[1.7em]' />}
                        </AnimatedButton>
                    </div>
                </div>
            </div>
            <BannerImage />
        </AnimatedPageFade>
    );
}

export default DOBPage;